import { CloseCircleOutlined } from "@ant-design/icons"
import { Button, Col, Divider, Image, Input, Popconfirm, Row, Space, Typography } from "antd"
import React from "react"

const { Text } = Typography
const { TextArea } = Input

export default function FlexoPriceSection({
  newKnife,
  newJob,
  knifeStartupPrice,
  plateStartup,
  totalPlateCost,
  knifePrice,
  dynamicPrice,
  handleAmountChange,
  removeAmountFields,
  handleAddAmount,
  cmykColors,
  pantoneColors,
  coveringWCount,
  varnishUse,
  goldOrSilver,
  reliefRunningMeters,
  foilCount,
  showFileButton,
  wasSentBack,
  dataFromState,
  adminComment,
  setAdminComment,
  wasSentFromDesigner,
  designerComment,
  setDesignerComment,
  handleTheTotalCalculate,
  labelCount,
  returnCorrectButton,
  templateName,
  setTemplateName,
  saveButtonDisabled,
  saveTemplate,
  totalLoading,
  handleRemoveFile,
  stateFileLink,
  recalculate = false,
  template = false,
  fromAdminState,
}) {
  const removeImageButton = () => {
    if (recalculate || template) {
      if (stateFileLink) {
        return (
          <Button danger onClick={() => handleRemoveFile()} block>
            Remove Image
          </Button>
        )
      }
    }
  }

  //shows image if there is one instead of an upload button
  const returnImageOrUpload = () => {
    if (dataFromState === null) {
      return (
        <>
          <Col span={10}>
            <Text>Image of the product</Text>
          </Col>
          <Col span={14}>{showFileButton(wasSentBack)}</Col>
        </>
      )
    } else {
      if (stateFileLink === null) {
        return (
          <>
            <Col span={10}>
              <Text>Image of the product</Text>
            </Col>
            <Col span={14}>{showFileButton(wasSentBack)}</Col>
          </>
        )
      } else {
        return (
          <>
            <Space direction="vertical">
              <Image src={stateFileLink} width={350} />
              {/* <Button
                onClick={handleRemoveFile}
                danger
                type="primary"
                icon={<CloseCircleOutlined />}>
                Remove
              </Button> */}
            </Space>
          </>
        )
      }
    }
  }

  function formatNumber(value) {
    if (!value && value !== 0) return "" // Handle null, undefined, and empty string
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  }

  return (
    <>
      <Row
        style={{ paddingRight: 45, paddingLeft: 45, paddingBottom: 45 }}
        align="middle"
        gutter={[2, 5]}>
        {/* CHECKS IF THE JOB IS NEW */}
        {newKnife || newJob ? (
          <>
            <Divider orientation="middle">Startup Costs</Divider>
            {/* IF NEW KNIFE, returns the price */}
            <Col span={24}>{newKnife ? <>{knifeStartupPrice()}</> : ""}</Col>
            {/* IF NEW JOB, returns the plate startup */}
            <Col span={24}>{newJob ? <>{plateStartup()}</> : ""}</Col>

            <Space>
              <Text>Total Startup (eur) :</Text>
              <Text style={{ color: "#1677ff" }}>{totalPlateCost + knifePrice}</Text>
            </Space>
            <Divider />
          </>
        ) : (
          ""
        )}

        {dynamicPrice && Object.keys(dynamicPrice).length > 0 ? (
          <>
            <Col flex="42%">
              <Text>Count</Text>
            </Col>
            <Col flex="58%">
              <Text>Price</Text>
            </Col>
          </>
        ) : (
          ""
        )}

        {dynamicPrice && Object.keys(dynamicPrice).length > 0
          ? Object.values(dynamicPrice).map((inputField, index) => (
              <div key={index}>
                <Row justify="end" align="middle">
                  <Col span={20}>
                    <Space.Compact block>
                      <Input
                        type="text" // Allow text input to accommodate spaces
                        style={{ width: "50%" }}
                        name="quantity"
                        value={formatNumber(inputField.quantity)} // Apply formatting function
                        onChange={(event) => handleAmountChange(index, event)}
                      />

                      <Input
                        style={{ width: "50%" }}
                        value={isFinite(inputField.price) ? inputField.price : 0}
                      />
                    </Space.Compact>
                  </Col>
                  <Col span={4}>
                    <Button type="primary" ghost danger onClick={() => removeAmountFields(index)}>
                      <CloseCircleOutlined />
                    </Button>
                  </Col>
                </Row>
              </div>
            ))
          : ""}

        <Button type="dashed" block onClick={() => handleAddAmount()}>
          Add More Prices
        </Button>

        <Divider />

        {cmykColors > 0 ||
        pantoneColors > 0 ||
        coveringWCount > 0 ||
        varnishUse > 0 ||
        goldOrSilver > 0 ||
        reliefRunningMeters > 0 ||
        foilCount > 0 ? (
          <>
            <Space style={{ width: "100%" }} direction="vertical">
              {returnImageOrUpload()}
              {removeImageButton()}
              <Divider />
            </Space>
          </>
        ) : (
          ""
        )}
        {/* CHECKS IF THERE IS A ADMIN COMMENT */}
        {dataFromState && dataFromState.sentBack ? (
          <>
            <Col span={24}>
              <Divider>Comment from Admin</Divider>
              <TextArea
                showCount
                value={adminComment && adminComment}
                style={{
                  height: 90,
                  marginBottom: 24,
                  allowClear: true,
                }}
                disabled
                onChange={(e) => setAdminComment(e.target.value)}
                placeholder="Add a comment"
              />
            </Col>
          </>
        ) : (
          ""
        )}
        {/* CHECKS IF THERE IS A DESIGNER COMMENT */}
        {wasSentFromDesigner && wasSentFromDesigner ? (
          <>
            <Col span={24}>
              <Divider>Comment from Designer</Divider>
              <TextArea
                showCount
                value={designerComment && designerComment}
                style={{
                  height: 90,
                  marginBottom: 24,
                  allowClear: true,
                }}
                disabled
                onChange={(e) => setDesignerComment(e.target.value)}
                placeholder="Add a comment"
              />
            </Col>
          </>
        ) : (
          ""
        )}
        {/* CHECKS IF SHOULD SHOW THE ADMIN COMMENT FROM SENT BACK */}
        {wasSentFromDesigner && wasSentFromDesigner ? (
          <>
            <Col span={24}>
              <Divider>Comment from Admin</Divider>
              <TextArea
                showCount
                value={adminComment && adminComment}
                style={{
                  height: 90,
                  marginBottom: 24,
                  allowClear: true,
                }}
                disabled
                onChange={(e) => setAdminComment(e.target.value)}
                placeholder="Add a comment"
              />
            </Col>
          </>
        ) : (
          ""
        )}

        <Button
          style={{ marginTop: "15px" }}
          onClick={() => handleTheTotalCalculate(labelCount)}
          type="primary"
          block>
          Calculate
        </Button>
        {returnCorrectButton()}
        <Divider />
        <Input
          placeholder="template name"
          value={templateName}
          onChange={(event) => setTemplateName(event.target.value)}
        />

        <Popconfirm
          disabled={saveButtonDisabled}
          title="Are you sure to you want to save?"
          onConfirm={(e) => saveTemplate(e)}
          okText="Yes"
          cancelText="No">
          <Button
            loading={totalLoading}
            disabled={saveButtonDisabled || wasSentFromDesigner || fromAdminState}
            type="dashed"
            block>
            {fromAdminState ? "Not your price" : "Save as Template"}
          </Button>
        </Popconfirm>
      </Row>
    </>
  )
}
